import { yupResolver } from '@hookform/resolvers/yup';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useForm, Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';
import * as yup from 'yup';
import _ from '@lodash';
import { startLoading, stopLoading } from 'app/store/utilSlice';
import { selectItemById, updateFileItem } from 'app/store/fileItemsSlice';
import { useSelector, useDispatch } from 'react-redux';
import { dispatchResultMessage } from '../utils';
import ControlledTextField from '../form/ControlledTextField';
import DefaultButton from '../layout/DefaultButton';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

const INDEX_MODE_OPTIONS = [
  { value: '', label: 'None' },
  { value: 'TEXT', label: 'Text Search' },
  { value: 'SEMANTIC', label: 'Semantic Search' },
  { value: 'HYBRID', label: 'Hybrid (Text + Semantic)' },
];

const schema = yup.object().shape({
  name: yup.string().required('You must enter a file name'),
  description: yup.string(),
  indexMode: yup.string(),
});

  
function EditFileDialog(props) {
  const { itemId, onCloseDialog } = props;
  const dispatch = useDispatch(); 
  const item = useSelector((state) => selectItemById(state, itemId));
  const open= Boolean(itemId);
  if (!item) return null;

  
  const defaultValues = {
	  name: '',
	  description: '',
	  indexMode: '',
  };
	
  const values = {
	  name: item ? item.name : '',
	  description: item ? item.description : '',
	  indexMode: item ? (item.indexMode || '') : '',
  };
  
  const { handleSubmit, formState, control, reset } = useForm({
    mode: 'onChange',
    defaultValues: defaultValues,
    values: values,
    resolver: yupResolver(schema),
  });

  const { isValid, dirtyFields, errors } = formState;
  
  useEffect(() => {
    reset({ ...item });
  }, [ item, reset]);

  function handleCloseDialog() {
    onCloseDialog();
  }

  function handleDiscard() {
    onCloseDialog();
  }

  
  function onSubmit(data){
	  if (!item) return;
	  
	  dispatch(startLoading());
    onCloseDialog();
	  
	  dispatch(updateFileItem({fileId: itemId, 
		                       name: data.name, 
		                       indexMode: data.indexMode || null,
		                       description: data.description})).then((resp) => {
	   	dispatchResultMessage(dispatch, resp, "Updated File")
     });
  }


  return (
      
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
        scroll="body"
      >
        <AppBar position="static" color="secondary" elevation={0}>
          <Toolbar className="flex w-full">
            <Typography variant="subtitle1" color="inherit">
              Update File
            </Typography>
          </Toolbar>
        </AppBar>

        <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
          <DialogContent classes={{ root: 'p-16 pb-0 sm:p-32 sm:pb-0' }}>
            <ControlledTextField name="name" label="File name"
                             control={control} errors={errors}
             				 autoFocus required fullWidth />
        
            <ControlledTextField name="description" label="File description"
                             control={control} errors={errors}
             				 required fullWidth />

            <Controller
              name="indexMode"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  select
                  label="Search Index Mode"
                  fullWidth
                  className="mt-16"
                  variant="outlined"
                >
                  {INDEX_MODE_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                  ))}
                </TextField>
              )}
            />  
          </DialogContent>

          <DialogActions className="flex flex-col sm:flex-row sm:items-center justify-between py-16 sm:py-24 px-24">

            <div className="flex items-center space-x-8 mt-16 sm:mt-0">
              <DefaultButton text="Cancel" onClick={handleDiscard} />
              <DefaultButton text="Update"
	              disabled={_.isEmpty(dirtyFields) || !isValid}
	              submit />
            </div>
          </DialogActions>
        </form>
      </Dialog>
  );
}

export default EditFileDialog;
